export default {"src":"/_next/static/media/0x5947bb275c521040051d82396192181b413227a3.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};